export default __webpack_public_path__ + "static/media/Chest.50b18deb.svg";